import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import qs from "qs";

export const useUrl = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const parseQueryString = () => {
    const queryString = location.search;
    const parsedFilters = qs.parse(queryString, {
      ignoreQueryPrefix: true,
    });
    return parsedFilters;
  };

  const queryStringApply = (objects: any) => {
    const queryString = qs.stringify(objects, { encode: true });
    const pathname = location.pathname;
    navigate({
      pathname,
      search: `?${queryString}`,
    });
  };

  const queryStringUrl = (pathname: string, object: any) => {
    const queryString = qs.stringify(object, { encode: true });
    return `/${pathname}?${queryString}`;
  };

  const setQueryString = (key: string, value: string) => {
    const preUrlQuery = parseQueryString();
    const queryString = qs.stringify(
      { ...preUrlQuery, [key]: value },
      { encode: true }
    );
    const pathname = location.pathname;
    navigate({
      pathname,
      search: `?${queryString}`,
    });
  };

  function mergeObjects(obj1: any, obj2: any) {
    const result = {};

    function mergeValues(val1: any, val2: any) {
      if (typeof val1 === "string" || typeof val1 === "number") {
        return val2;
      }
      if (Array.isArray(val1) && Array.isArray(val2)) {
        return [...val1, ...val2];
      } else if (Array.isArray(val1)) {
        return [...val1, val2];
      } else if (Array.isArray(val2)) {
        return [val1, ...val2];
      } else if (typeof val1 === "object" && typeof val2 === "object") {
        return mergeObjects(val1, val2);
      }
      return [val1, val2];
    }

    for (const key in obj1) {
      if (key in obj2) {
        // @ts-ignore
        result[key] = mergeValues(obj1[key], obj2[key]);
      } else {
        // @ts-ignore
        result[key] = obj1[key];
      }
    }

    for (const key in obj2) {
      if (!(key in obj1)) {
        // @ts-ignore
        result[key] = obj2[key];
      }
    }

    return result;
  }

  const addToQueryStringUrl = (pathname: any, object: any) => {
    const parsedObject = parseQueryString();
    const updatedObject = mergeObjects(parsedObject, object);
    return queryStringUrl(pathname, updatedObject);
  };

  const getQueryString = (key: string) => {
    const preUrlQuery = parseQueryString();
    const value = preUrlQuery[key];
    return value;
  };

  const setParamWithSearchParams = (key: string, value: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(key, value);
    setSearchParams(newParams);
  };

  return {
    parseQueryString,
    queryStringApply,
    setQueryString,
    queryStringUrl,
    addToQueryStringUrl,
    getQueryString,
    setParamWithSearchParams,
  };
};
